'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getParamsNmr = function getParamsNmr(_ref) {
  var molfile = _ref.molfile,
      peaks = _ref.peaks,
      layout = _ref.layout,
      shift = _ref.shift;

  var jsonPeaks = JSON.stringify(peaks);
  var jsonShift = JSON.stringify(shift);
  var data = new FormData();
  data.append('molfile', molfile);
  data.append('layout', layout);
  data.append('peaks', jsonPeaks);
  data.append('shift', jsonShift);

  var url = '/api/v1/chemspectra/predict/nmr_peaks_form';

  return { url: url, data: data };
};

var getParamsIr = function getParamsIr(_ref2) {
  var molfile = _ref2.molfile,
      spectrum = _ref2.spectrum;

  var data = new FormData();
  data.append('molfile', molfile);
  data.append('spectrum', spectrum);

  var url = '/api/v1/chemspectra/predict/infrared';

  return { url: url, data: data };
};

var predict = function predict(payload) {
  var layout = payload.layout;

  var params = layout === 'IR' ? getParamsIr(payload) : getParamsNmr(payload);
  var url = params.url,
      data = params.data;


  var promise = fetch(url, {
    credentials: 'same-origin',
    method: 'post',
    body: data
  }).then(function (response) {
    return response.json();
  }).then(function (json) {
    return json;
  }).catch(function (err) {
    console.log(err); // eslint-disable-line
  });

  return promise;
};

var FetcherPredict = {
  predict: predict
};

exports.default = FetcherPredict;